import { findInformation, PatientInformation } from "../commons/model/patient/PatientInfo";
import { InsuranceInfo } from "../patient-portal/InsuranceInfo";
import { DentalInfo } from "../patient-portal/DentalInfo";
import { HealthHistoryInfo } from "../patient-portal/HealthHistoryInfo";
import { AuthorizationInfo } from "../patient-portal/AuthorizationInfo";
import { HouseholdInfo } from "../patient-portal/HouseholdInfo";
import Field from "../commons/model/form/Field";

export interface PatientProfile {
  personalInformation?: PatientInformation;
  primaryInsuranceInformation?: InsuranceInfo;
  secondaryInsuranceInformation?: InsuranceInfo;
  dentalInformation?: DentalInfo;
  healthHistoryInformation?: HealthHistoryInfo;
  authorizationInformation?: AuthorizationInfo;
  householdInformation?: HouseholdInfo;
  completeProfile: boolean;
}

export interface PatientProfileWithConfiguration {
  patientProfile: PatientProfile;
  configuration: PatientFormConfig;
  isLinkedToADoctor: boolean;
  showLeadStatus: boolean;
}

export enum PatientInformationSection {
  PERSONAL_INFO = "personalInfo",
  HOUSEHOLD_INFO = "householdInfo",
  INSURANCE_INFO = "insuranceInfo",
  DENTAL_INFO = "dentalInfo",
  HEALTH_HISTORY_INFO = "healthHistoryInfo",
  AUTHORIZATION_INFO = "authorizationInfo",
}

export interface PatientProfileView {
  patientProfile: PatientProfile;
  configuration: PatientFormConfig;
  availableSections: PatientInformationSection[];
  isLinkedToADoctor: boolean;
  showLeadStatus: boolean;
}

export interface PatientFormConfig {
  insuranceInfo: InsuranceFormConfiguration;
  personalInfo: PersonalFormConfiguration;
  dentalInfo: FormConfiguration;
  healthHistoryInfo: FormConfiguration;
  authorizationInfo: AuthorizationFormConfiguration;
  householdInfo: FormConfiguration;
}

export interface FormConfiguration {
  fields: Field[];
  updateUrl: string;
}

export interface InsuranceFormConfiguration extends FormConfiguration {
  supportedTypes: string[];
}

export interface PersonalFormConfiguration extends FormConfiguration {
  showPhoneDisclaimer: boolean;
  showSomePersonalInfosNonEditableDisclaimer: boolean;
}

export interface AuthorizationFormConfiguration extends FormConfiguration {
  practiceLegalName: string;
}

export const hasCompletePersonalInformations = (
  patientProfileWithConfiguration: PatientProfileWithConfiguration
): boolean => {
  return patientProfileWithConfiguration.configuration.personalInfo.fields
    .filter((field) => field.mandatory === true)
    .reduce((result, field) => {
      const foundInformation = findInformation(
        field.key,
        patientProfileWithConfiguration.patientProfile.personalInformation
      );
      return result && foundInformation !== null && foundInformation !== undefined;
    }, true);
};
